import React, { useState } from "react";
import style from "./SignIn.module.css";
import PageLayout from "../../components/PageLayout/PageLayout";

import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  authUser,
  clearMsg,
  selectAuthMsg,
} from "../../slices/auth/authSlice";

import FormikField from "../../stuffs/FormikField/FormikField";
import * as Yup from "yup";

import {
  useHistory,
  NavLink,
} from "react-router-dom";

import {
  Modal,
  Button as ButtonModal,
  Spinner,
} from "react-bootstrap";

import { Button } from "@mui/material";

interface FormValues {
  email: string;
  password: string;
}

const initialValues: FormValues = {
  email: "",
  password: "",
};

const SignIn: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const msgAuth = useSelector(selectAuthMsg);

  const [show, setShow] = useState(false);

  const AuthSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wymagany poprawny adres email!")
      .required("Pole wymagane"),

    password: Yup.string().required(
      "Pole wymagane!"
    ),
  });

  const handleSubmit = (
    values: FormValues
  ): void => {
    dispatch(authUser(values));
    setShow(true);
  };

  const handleDeleteMsg = () => {
    setShow(false);
    dispatch(clearMsg());

    if (msgAuth === "Jesteś zalogowany") {
      history.push("/");
    }
  };

  return (
    <PageLayout>
      <div className={style.SignIn}>
        <div className={style.LoginBox}>
          <h1>Zaloguj</h1>

          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={AuthSchema}
          >
            {({
              isValid,
              dirty,
              errors,
              touched,
            }) => (
              <Form className={style.Form}>
                <div className={style.Field}>
                  <FormikField
                    name="email"
                    label="Email"
                    variant="standard"
                    required
                    err={
                      errors.email &&
                      touched.email
                    }
                  />
                </div>

                <div className={style.Field}>
                  <FormikField
                    name="password"
                    label="Password"
                    variant="standard"
                    type="password"
                    required
                    err={
                      errors.password &&
                      touched.password
                    }
                  />
                </div>

                <div className={style.Button}>
                  <Button
                    variant="outlined"
                    disabled={
                      !dirty || !isValid
                    }
                    type="submit"
                  >
                    Zaloguj
                  </Button>
                </div>
              </Form>
            )}
          </Formik>

          <div className={style.Links}>
            <div>
              Nie masz konta?{" "}
              <NavLink
                exact
                to="/signup"
                className={style.MenuItem}
              >
                Zarejestruj się.
              </NavLink>
            </div>

            <div>
              <NavLink
                to="/forgot-password"
                className={style.MenuItem}
              >
                Nie pamiętasz hasła?
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleDeleteMsg}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {msgAuth ? (
              msgAuth
            ) : (
              <Spinner animation="border" />
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <ButtonModal
            variant="primary"
            onClick={handleDeleteMsg}
          >
            Zamknij
          </ButtonModal>
        </Modal.Footer>
      </Modal>
    </PageLayout>
  );
};

export default SignIn;